import { render, staticRenderFns } from "./LayersHeader.vue?vue&type=template&id=c6ddbdda&scoped=true"
import script from "./LayersHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./LayersHeader.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./LayersHeader.vue?vue&type=style&index=0&id=c6ddbdda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ddbdda",
  null
  
)

export default component.exports